/**
 * @file home页
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-08-28 Baidu
 */

import React from 'react';
import {Table, Tabs, Icon, Divider} from 'antd';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {requestCreateDemo, requestQueryDemo} from './requestDemoV2';
import {setCurrentPage} from '../../actions/generalAction';
import './index.less';

const TabPane = Tabs.TabPane;

const createResDemo = `
{
    "Code": 0,
    "ShortUrl": "https://dwz.cn/de3rp2Fl",
    "LongUrl": "http://www.baidu.com",
    "ErrMsg": ""
}`;
const queryResDemo = `
{
    "Code": 0,
    "ShortUrl": "https://dwz.cn/de3rp2Fl",
    "LongUrl": "http://www.baidu.com",
    "ErrMsg": ""
}`;
const deleteResDemo = `
{
    "Code": -100,
    "ErrMsg": "token is invalid"
}`;
const renderContentOfCreate = (value, _, index) => {
    const obj = {
        children: value,
        props: {}
    };
    if (index === 0) {
        obj.props.rowSpan = 8;
    }
    else if (index <= 7) {
        obj.props.rowSpan = 0;
    }
    else {
        obj.props.rowSpan = 1;
    }
    return obj;
};
const renderContentOfQuery = (value, _, index) => {
    const obj = {
        children: value,
        props: {}
    };
    if (index === 0) {
        obj.props.rowSpan = 5;
    }
    else if (index <= 4) {
        obj.props.rowSpan = 0;
    }
    else {
        obj.props.rowSpan = 1;
    }
    return obj;
};
const renderContentOfDelete = (value, _, index) => {
    const obj = {
        children: value,
        props: {}
    };
    if (index === 0) {
        obj.props.rowSpan = 5;
    }
    else if (index <= 4) {
        obj.props.rowSpan = 0;
    }
    else {
        obj.props.rowSpan = 1;
    }
    return obj;
};
class APIDoc extends React.Component {
    state = {
        announceDisplay: 'block'
    }
    linkToUserInfo() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', 'API接口文档页', 'apidoc_click_tokenlink', '点击获取Token链接']);
        this.props.dispatch(setCurrentPage('userinfo'));
    }
    closeAnnoce() {
        this.setState({
            announceDisplay: 'none'
        });
    }
    render() {
        const path = {
            head: [{
                title: '字段',
                dataIndex: 'shortPath',
                key: 'shortPath'
            },
            {
                title: '类型',
                dataIndex: 'shortPathType',
                key: 'shortPathType'
            },
            {
                title: '是否必须',
                dataIndex: 'shortPathRequire',
                key: 'shortPathRequire'
            },
            {
                title: '说明',
                dataIndex: 'shortPathDescribe',
                key: 'shortPathDescribe'
            },
            {
                title: '示例',
                dataIndex: 'shortPathDemo',
                key: 'shortPathDemo',
            }],
            body: [{
                key: 1,
                shortPath: 'short_path',
                shortPathType: 'string',
                shortPathRequire: '必须',
                shortPathDescribe: '短网址后缀，如http://dwz.cn/testPath中的testPath',
                shortPathDemo: 'testPath'
            }]
        };
        const dwzToken = {
            body: [{
                key: 1,
                token: 'Dwz-Token',
                tokenType: 'string',
                tokenRequire: '必须',
                tokenDescribe: '用户鉴权信息'
            }]
        };
        const token = {
            head: [{
                title: '字段',
                dataIndex: 'token',
                key: 'token'
            },
            {
                title: '类型',
                dataIndex: 'tokenType',
                key: 'tokenType'
            },
            {
                title: '是否必须',
                dataIndex: 'tokenRequire',
                key: 'tokenRequire'
            },
            {
                title: '说明',
                dataIndex: 'tokenDescribe',
                key: 'tokenDescribe'
            },
            {
                title: '示例',
                dataIndex: 'tokenDemo',
                key: 'tokenDemo',
                render: () => <Link to="/console/userinfo" onClick={() => this.linkToUserInfo()}>获取token</Link>
            }],
            body: [{
                key: 1,
                token: 'Token',
                tokenType: 'string',
                tokenRequire: '必须',
                tokenDescribe: '由数字和字母组成的32位字符'
            }]
        };
        return (
            <div className="doc-container">
                <div className="apidoc-content">
                    <h2 className="title">短网址生成接口</h2>
                    <ul>
                        <h3>请求地址</h3>
                        <li>
                            <span>https://dwz.cn/admin/v2/create</span>
                        </li>
                        <h3>请求方式</h3>
                        <li>
                            <span>POST</span>
                        </li>
                        <h3>Content-Type:</h3>
                        <li>
                            <span>application/json; charset=UTF-8</span>
                        </li>
                        <h3>请求参数（Headers）</h3>
                        <Table columns={token.head} dataSource={token.body} pagination={false} />
                        <h3>请求参数（Body）</h3>
                        <Table columns={this.props.create.reqHead}
                            dataSource={this.props.create.reqBody} pagination={false}
                        />
                        <h3>请求示例</h3>
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="Java" key="1"><pre>{requestCreateDemo().java}</pre></TabPane>
                            <TabPane tab="curl" key="2"><pre>{requestCreateDemo().curl}</pre></TabPane>
                            <TabPane tab="JavaScript" key="3"><pre>{requestCreateDemo().javascript}</pre></TabPane>
                            <TabPane tab="PHP" key="5"><pre>{requestCreateDemo().php}</pre></TabPane>
                            <TabPane tab="Python" key="6"><pre>{requestCreateDemo().python}</pre></TabPane>
                        </Tabs>
                        <h3>响应结果示例</h3>
                        <pre>{this.props.create.createResDemo}</pre>
                        <h3>响应参数说明</h3>
                        <Table columns={this.props.create.resHead}
                            dataSource={this.props.create.resBody} pagination={false}
                        />
                    </ul>
                    <Divider className='divider'/>
                    <h2 className="title">短网址还原接口</h2>
                    <ul>
                        <h3>请求地址</h3>
                        <li>
                            <span>https://dwz.cn/admin/v2/query</span>
                        </li>
                        <h3>请求方式</h3>
                        <li>
                            <span>POST</span>
                        </li>
                        <h3>Content-Type:</h3>
                        <li>
                            <span>application/json; charset=UTF-8</span>
                        </li>
                        <h3>请求数据结构</h3>
                        <li>
                            <span>JSON</span>
                        </li>
                        <h3>请求参数（Headers）</h3>
                        <Table columns={token.head} dataSource={token.body} pagination={false} />
                        <h3>请求参数（Body）</h3>
                        <Table columns={this.props.query.reqHead}
                            dataSource={this.props.query.reqBody} pagination={false}
                        />
                        <h3>请求示例</h3>
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="Java" key="1"><pre>{requestQueryDemo().java}</pre></TabPane>
                            <TabPane tab="curl" key="2"><pre>{requestQueryDemo().curl}</pre></TabPane>
                            <TabPane tab="JavaScript" key="3"><pre>{requestQueryDemo().javascript}</pre></TabPane>
                            <TabPane tab="PHP" key="5"><pre>{requestQueryDemo().php}</pre></TabPane>
                            <TabPane tab="Python" key="6"><pre>{requestQueryDemo().python}</pre></TabPane>
                        </Tabs>
                        <h3>响应结果示例</h3>
                        <pre>{this.props.query.queryResDemo}</pre>
                        <h3>响应参数说明</h3>
                        <Table columns={this.props.query.resHead}
                            dataSource={this.props.query.resBody} pagination={false}
                        />
                    </ul>
                </div>
            </div>
        );
    }
}
APIDoc.defaultProps = {
    create: {
        reqDemo: '{"Url":"http://www.baidu.com"}',
        createResDemo,
        reqHead: [{
            title: '字段',
            dataIndex: 'crReqName',
            key: 'crReqName'
        },
        {
            title: '类型',
            dataIndex: 'crReqType',
            key: 'crReqType'
        },
        {
            title: '是否必须',
            dataIndex: 'crReqRequire',
            key: 'crReqRequire'
        },
        {
            title: '说明',
            dataIndex: 'crReqDescribe',
            key: 'crReqDescribe',
            render: (text, _) => (
                <span>
                    {text}
                    {text === '短网址有效期，目前支持：'
                        && <span>
                            <ul className="termOfValidityDes">
                                <li>"long-term"：长期，默认值</li>
                                <li>"1-year"：1年</li>
                            </ul>
                            <div style={{color: 'red'}}>目前创建的短网址分一年有效和长期有效。请根据场景需要选择相应的有效期，过期后短链无法正常访问。</div>
                        </span>
                    }
                </span>
            )
        },
        {
            title: '示例',
            dataIndex: 'crReqDemo',
            key: 'crReqDemo'
        }],
        reqBody: [
            {
                key: 1,
                crReqName: 'Url',
                crReqType: 'string',
                crReqRequire: '必须',
                crReqDescribe: '长网址',
                crReqDemo: '"http://www.baidu.com"'
            },
            {
                key: 2,
                crReqName: 'TermOfValidity',
                crReqType: 'string',
                crReqRequire: '非必须',
                crReqDescribe: '短网址有效期，目前支持：',
                crReqDemo: '"long-term"'
            }
        ],
        // create head
        resHead: [{
            title: '字段',
            dataIndex: 'crResName',
            key: 'crResName',
            render: renderContentOfCreate
        },
        {
            title: '类型',
            dataIndex: 'crResType',
            key: 'crResType',
            render: renderContentOfCreate
        },
        {
            title: '说明',
            dataIndex: 'crResDescribe',
            key: 'crResDescribe'
        }],
        // create body
        resBody: [{
            key: 1,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '0：正常返回短网址'
        },
        {
            key: 2,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-1：短网址生成失败'
        },
        {
            key: 3,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-2：长网址不合法'
        },
        {
            key: 4,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-3：长网址存在安全隐患'
        },
        {
            key: 5,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-4：内部错误'
        },
        {
            key: 6,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-5：短网址服务目前不支持该域名'
        },
        {
            key: 7,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-6：有效期设置错误'
        },
        {
            key: 8,
            crResName: 'Code',
            crResType: 'int',
            crResDescribe: '-1xx：Token验证失败'
        },
        {
            key: 9,
            crResName: 'ShortUrl',
            crResType: 'string',
            crResDescribe: '短网址'
        },
        {
            key: 10,
            crResName: 'LongUrl',
            crResType: 'string',
            crResDescribe: '长网址（原网址）'
        },
        {
            key: 11,
            crResName: 'ErrMsg',
            crResType: 'string',
            crResDescribe: '错误信息'
        }]
    },
    query: {
        reqDemo: '{"shortUrl": "https://dwz.cn/de3rp2Fl"}',
        queryResDemo,
        reqHead: [{
            title: '字段',
            dataIndex: 'quReqName',
            key: 'quReqName'
        },
        {
            title: '类型',
            dataIndex: 'quReqType',
            key: 'quReqType'
        },
        {
            title: '是否必须',
            dataIndex: 'quReqRequire',
            key: 'quReqRequire'
        },
        {
            title: '说明',
            dataIndex: 'quReqDescribe',
            key: 'quReqDescribe'
        },
        {
            title: '示例',
            dataIndex: 'quReqDemo',
            key: 'quReqDemo'
        }],
        reqBody: [{
            key: 1,
            quReqName: 'shortUrl',
            quReqType: 'string',
            quReqRequire: '必须',
            quReqDescribe: '短网址',
            quReqDemo: '"https://dwz.cn/de3rp2Fl"'
        }],
        // create response TableHead
        resHead: [{
            title: '字段',
            dataIndex: 'quResName',
            key: 'quResName',
            render: renderContentOfQuery
        },
        {
            title: '类型',
            dataIndex: 'quResType',
            key: 'quResType',
            render: renderContentOfQuery
        },
        {
            title: '说明',
            dataIndex: 'quResDescribe',
            key: 'quResDescribe'
        }],
        // query response tableBody
        resBody: [{
            key: 1,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '0：正常返回短网址'
        },
        {
            key: 2,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '-1：短网址对应的长网址不合法'
        },
        {
            key: 3,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '-2：短网址不存在'
        },
        {
            key: 4,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '-3：查询的短网址不合法'
        },
        {
            key: 5,
            quResName: 'Code',
            quResType: 'int',
            quResDescribe: '-1xx：Token验证失败'
        },
        {
            key: 6,
            quResName: 'ShortUrl',
            quResType: 'string',
            quResDescribe: '短网址'
        },
        {
            key: 7,
            quResName: 'LongUrl',
            quResType: 'string',
            quResDescribe: '长网址（原网址）'
        },
        {
            key: 8,
            quResName: 'ErrMsg',
            quResType: 'string',
            quResDescribe: '错误信息'
        }]
    },
    delete: {
        deleteResDemo,
        resHead: [{
            title: '字段',
            dataIndex: 'delResName',
            key: 'delResName',
            render: renderContentOfDelete
        },
        {
            title: '类型',
            dataIndex: 'delResType',
            key: 'delResType',
            render: renderContentOfDelete
        },
        {
            title: '说明',
            dataIndex: 'delResDescribe',
            key: 'delResDescribe'
        }],
        resBody: [{
            key: 1,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '0：成功'
        },
        {
            key: 2,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-1：短网址参数错误'
        },
        {
            key: 3,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-2或-4：短网址不存在'
        },
        {
            key: 4,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-3：无权操作短网址'
        },
        {
            key: 5,
            delResName: 'Code',
            delResType: 'int',
            delResDescribe: '-1xx：Token验证失败'
        },
        {
            key: 6,
            delResName: 'ErrMsg',
            delResType: 'string',
            delResDescribe: '错误信息'
        }]
    }
};
export default connect(state => ({
    currentPage: state.currentPage
}))(APIDoc);